if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      var main_this = this;
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var _cart = this.cart;
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      $(this).closest('.grid__item').find('.qty-cover-count-flex .qty-plus').on('click',function(e){
        e.preventDefault();
        var _this = $(this);
        var _form = $(this).closest('form');
        var main_val = parseInt(_this.closest('.listing_form_wrapper').find('.qty-cover-left-inner input[type="number"]').val());
        var form = $(this).closest('.listing_form_wrapper');
        var input_len = form.find('.variant_id').length;
        var id = parseInt(form.find('.variant_id').val());
        var max = parseInt(form.find('.variant_id option:selected').data('max'));
        console.log(main_val,id);
         $.ajax({
          url: '/cart.js',
          dataType: 'json',
          type: 'get',
          success: function(data){
            var val = 0;
            data.items.forEach(function(item, index){
              console.log(item.variant_id,item.quantity);
              if(item.variant_id == id){
                val = item.quantity;
              }
            })
            var final_val = val;
            console.log(final_val)
            if(final_val < max && main_val <= max){
              final_val += 1;

              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
              

             // $.ajax({
             //  type: "post",
             //  url: "/cart/add.js",
             //  data: 'quantity=1&id='+id,
             //  dataType: "json",
             //  success: function(data){
                // form.find('.qty-cover-left-inner input[type="number"]').val(final_val);
                // form.find('.qty-cover-count-flex input.quantity__input').val(final_val+' in basket');
                // form.addClass("active_qty_btn");
             //    console.log(data);
             //  },
             //  error: function(err){
             //    console.log(err);
             //  }
             // }) 
              const formData = new FormData(_form[0]);
              if (main_this.cart) {
                formData.append('sections', main_this.cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                main_this.cart.setActiveElement(document.activeElement);
              }
            
              config.body = formData;
              
                  console.log(config.body);
                fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                      console.log(response)
                   main_this.cart.CustomrenderContents(response);
                        form.find('.qty-cover-left-inner input[type="number"]').val(final_val);
                    form.find('.qty-cover-count-flex input.quantity__input').val(final_val+' in basket');
                    form.addClass("active_qty_btn");
                    form.find('.variant_id option:selected').attr('data-qty-val',final_val+' in basket');
                    form.find('.variant_id option:selected').attr('data-val',final_val);
                  })
                  .catch((e) => {
                    console.error(e);
                  })
            }else{
              form.find('.qty-cover-left-inner input[type="number"]').val(max);
            }
          },
          error: function(err){
            console.log(err);
          }
        })
        return false;
      });

      $('.product-form--atc-button').unbind('click').on('click',function(e){
        e.preventDefault();
        var _this = $(this);
        var main_val = parseInt(_this.closest('.listing_form_wrapper').find('.qty-cover-left-inner input[type="number"]').val());
         var _form = $(this).closest('form');
        var form = $(this).closest('.listing_form_wrapper');
        var input_len = form.find('.variant_id').length;
        var id = parseInt(form.find('.variant_id').val());
        var max = parseInt(form.find('.variant_id option:selected').data('max'));
        console.log(main_val,id);
         $.ajax({
          url: '/cart.js',
          dataType: 'json',
          type: 'get',
          success: function(data){
            var val = 0;
            data.items.forEach(function(item, index){
              console.log(item.variant_id,item.quantity);
              if(item.variant_id == id){
                val = item.quantity;
              }
            })
            var final_val = val+main_val;
            console.log(final_val,main_val);
            if(final_val <= max){
             // $.ajax({
             //  type: "post",
             //  url: "/cart/add.js",
             //  data: 'quantity='+main_val+'&id='+id,
             //  dataType: "json",
             //  success: function(data){
             //    form.find('.qty-cover-left-inner input[type="number"]').val(final_val);
             //    form.find('.qty-cover-count-flex input.quantity__input').val(final_val+' in basket');
             //    form.addClass("active_qty_btn");
             //    console.log(data);
             //  },
             //  error: function(err){
             //    console.log(err);
             //  }
             // });
             _this.closest('.card__content').find('.quick-add form [name="quantity"]').val(final_val)
              _this.closest('.card__content').find('.quick-add form .quick-add__submit')[0].click();
               form.find('.qty-cover-left-inner input[type="number"]').val(final_val);
                form.find('.qty-cover-count-flex input.quantity__input').val(final_val+' in basket');
                form.addClass("active_qty_btn");
              form.find('.variant_id option:selected').attr('data-qty-val',final_val+' in basket');
              form.find('.variant_id option:selected').attr('data-val',final_val);
            }else{
              _this.closest('.card__content').find('.quick-add form [name="quantity"]').val(max);
              form.find('.qty-cover-left-inner input[type="number"]').val(max);
              form.find('.variant_id option:selected').attr('data-qty-val',final_val+' in basket');
              form.find('.variant_id option:selected').attr('data-val',final_val);
            }
            
          },
          error: function(err){
            console.log(err);
          }
        })
        return false;
      })
      
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      console.log(this.form)
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      console.log(this.cart);
      config.body = formData;
      console.log(formData)
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          // $('.header__icon.header__icon--cart')[0].click();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
